import styled from "styled-components";
import Color from "../../../assets/Colors";
import {Link} from "react-router-dom";
import {ContentContainer} from "../../../styles/Products";

export const TitleContainer = styled.div`
   display: flex;
   width: 100%;
   margin-top: 30px;

   @media screen and (min-width: 501px) {
      &.centerDesk {
         justify-content: center;
      }
   }

   & .titleIcon {
      width: 2.3em;
      height: 1.8em;
      margin-right: 1.5em;
      margin-top: 5px;
      &.facilitador {
         width: 2.8em;
      }
      &.large {
         width: 2.4em;
      }
      &.sLarge {
         width: 2.6em;
      }
      &.min {
         width: 1.9em;
      }
   }

   @media screen and (max-width: 1600px) {
      & .titleIcon {
         width: 1.6em;
         height: 1.333em;
         margin-right: 1em;

         &.large {
            width: 1.8em;
         }
         &.sLarge {
            width: 2.1em;
         }
         &.facilitador {
            width: 1.8em;
         }
         &.min {
            width: 1.3em;
         }
      }
   }
   @media screen and (max-width: 500px) {
      width: auto;
      align-items: center;
      //margin-right: auto;
      //margin-left: auto;

      & .titleIcon {
         width: 1.4em;
         height: 1.1em;
         margin-right: 0.7em;
         margin-top: 3px;

         &.large {
            width: 1.4em;
         }
         &.facilitador {
            width: 1.4em;
         }
         &.min {
            width: 1.2em;
         }
         &.sLarge {
            width: 1.6em;
         }
      }
   }
`;

export const SectionDetail = styled.div`
   padding: 6em 0;
   width: 100%;
   //border-top: 1px solid rgba(22, 49, 77, 0.3);

   display: flex;
   flex-direction: column;
   align-items: center;
   // justify-content: space-between;

   & > .child {
      display: flex;
      flex-direction: column;
      align-items: center;
      border-top: 1px solid grey;
   }
   @media screen and (max-width: 1600px) {
      padding: 4em 0;
   }
   &:last-child {
      padding-bottom: 0;
   }
   &.notBorder {
      border: none;
      padding-top: 0;
      & ${TitleContainer} {
         margin-bottom: 2em;
      }
   }
   @media screen and (max-width: 500px) {
      padding: 2em 0;
      align-items: flex-start;
      & > .child {
         align-items: flex-start;
      }
   }
`;

export const TitleSection = styled.p`
   font-size: 1.9em;
   font-weight: ${(props) => props.weight || "200"};
   text-transform: uppercase;
   color: ${Color.primary};

   & .icon {
      height: 1.5em;
      width: 1.5em;
      &.large {
         width: 1.8em;
      }
   }

   @media screen and (max-width: 1600px) {
      font-size: 1.5em;
      & .icon {
         height: 1em;
         width: 1.4em;
         &.large {
            width: 1.5em;
         }
      }
   }
   @media screen and (max-width: 500px) {
      font-size: 1em;
      & .icon {
         height: 1em;
         width: 1.4em;
         &.large {
            width: 1.3em;
         }
      }
   }
`;

export const InfoDetail = styled.div`
   width: 100%;
   display: flex;
   flex-direction: column;
   align-items: center;
   &:nth-child(2) {
      margin-top: 3em;
      // margin-right: 100px;
   }
   @media screen and (max-width: 500px) {
      width: 100%;
      margin-top: 0em;
      align-items: flex-start;
      &:nth-child(2) {
         margin-right: 0px;
      }
   }
`;

export const SubtitleDetail = styled.p`
   color: ${Color.primary};
   font-weight: bold;
   &.light {
      font-weight: 300;
   }
   font-size: 1.7em;
   margin-bottom: 0.5em;
   @media screen and (max-width: 1600px) {
      font-size: 1.2em;
   }
   @media screen and (max-width: 500px) {
      font-size: 1em;
      &.light {
         font-weight: 300;
      }
   }
`;

export const ListDetail = styled.ul`
   padding-left: 2em;
   margin-bottom: 2em;
   @media screen and (max-width: 500px) {
      margin-left: 0em;
      margin-top: 1em;
   }
`;

export const ListThemes = styled.ul`
   padding-left: 2em;
   margin-bottom: 1em;
`;

export const TextDetail = styled.p`
   font-weight: 200;
   color: ${Color.textColor};
   font-size: 1.5em;
   line-height: 1.6em;

   & .mediaIcon {
      width: 1.2em;
      height: 1.2em;
      margin-left: 0.5em;
   }

   @media screen and (max-width: 1600px) {
      font-size: 1em;
      line-height: 1.5em;
   }
   @media screen and (max-width: 500px) {
      font-size: 0.9em;
      // line-height: 1.2em;
      &.date {
         white-space: nowrap;
         margin-right: 0.5em;
      }
   }

   /*  &.itemList {
      padding-left: 1em;
   } */
`;

export const PreStyled = styled.div`
   width: 75%;
   margin: 0 auto;
   & p {
      margin-bottom: 0.5em;
   }
   & ul {
      padding-left: 1em;
      & li {
         margin-bottom: 0.5em;
      }
   }
   & p,
   li {
      font-weight: 200;
      color: ${Color.textColor};
      font-size: 1.5em;
      line-height: 1.6em;

      @media screen and (max-width: 1600px) {
         font-size: 1em;
         line-height: 1.5em;
      }

      @media screen and (max-width: 500px) {
         font-size: 0.9em;
         // line-height: 1.2em;
      }
   }
   &.date {
      white-space: nowrap;
      margin-right: 0.5em;
   }
   & .mediaIcon {
      width: 1.2em;
      height: 1.2em;
      margin-left: 0.5em;
   }
`;

export const ColDetail = styled.div`
   display: flex;
   justify-content: center;
   margin-bottom: 1.2em;
   text-align: center;

   & .date {
      width: 300px;
   }
   & .textNextCourse {
      width: 250px;
      line-height: 1.4em;
   }

   @media screen and (max-width: 1600px) {
      & .date {
         width: 230px;
      }
      & .textNextCourse {
         width: 200px;
         line-height: 1.4em;
      }
   }
   @media screen and (max-width: 500px) {
      justify-content: flex-start;
      width: 100%;

      & .date {
         width: 50%;
      }
      & .textNextCourse {
         width: 50%;
         line-height: 1.4em;
      }
   }
`;

export const DisableNext = styled(TextDetail)`
   font-weight: bold;
   @media screen and (max-width: 500px) {
      font-size: 0.9em;
      line-height: 1.1em;
   }
`;

export const ActionNext = styled(Link)`
   font-weight: bold;
   color: ${Color.secondary};
   font-size: 1.5em;
   line-height: 1.5em;

   & .mediaIcon {
      width: 1em;
      height: 1em;
      margin-left: 1em;
   }

   @media screen and (max-width: 1600px) {
      font-size: 1em;
      & .mediaIcon {
         width: 0.9em;
         height: 0.9em;
         margin-left: 0.5em;
      }
   }
   @media screen and (max-width: 500px) {
      font-size: 0.9em;
      line-height: 1.1em;
   }
`;

export const SubtitleContainer = styled.div`
   width: 70%;
`;

export const SectionWithSubtitle = styled.div`
   width: 100%;
   display: flex;
   align-items: center;
   justify-content: space-between;

   & ${TitleContainer} {
      width: 30%;
   }
`;

export const FullExpe = styled.div`
   width: 49%;
   padding: 0.5em;
`;
